import { Stack, Typography, Button, Slide } from '@mui/material';
import { useCookieConsent } from '../../hooks/useCookieConsent';
import { dictionary } from '../../dictionary';
import { palette } from '../../theme';
import CookieOutlinedIcon from '@mui/icons-material/CookieOutlined';

export default function CookieConsent() {
  const { accepted, accept } = useCookieConsent();

  if (accepted) return null;

  return (
    <Slide direction='up' in={!accepted}>
      <Stack
        direction={'row'}
        alignItems='center'
        justifyContent='center'
        gap={{ mobile: '12px', laptop: '40px' }}
        sx={{
          position: 'fixed',
          bottom: 16,
          left: 0,
          right: 0,
          mx: 'auto',
          zIndex: 1400,
          backgroundColor: palette.primary,
          color: palette.white,
          p: '12px',

          borderRadius: '80px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.25)',
          width: { mobile: 'calc(100% - 32px)', laptop: 'fit-content' },
          maxWidth: 700,
        }}
      >
        <Stack direction={'row'} gap={'8px'}>
          <CookieOutlinedIcon sx={{ fontSize: '24px', color: palette.backgroundSections }} />
          <Typography variant='body2' sx={{ color: palette.backgroundSections }}>
            {dictionary.general.cookieConsent.message}
          </Typography>
        </Stack>
        <Button
          variant='contained'
          onClick={accept}
          size='small'
          sx={{
            backgroundColor: palette.accent,
            color: palette.primary,
            '&:hover': {
              backgroundColor: palette.backgroundSections,
            },
          }}
        >
          {dictionary.general.cookieConsent.accept}
        </Button>
      </Stack>
    </Slide>
  );
}
